import NetInfo from '@react-native-community/netinfo';

type NetworkErrorShape = {
  statusCode?: number;
  message?: string;
};

const normalizeNetworkError = (error: unknown): NetworkErrorShape => {
  if (typeof error !== 'object' || error === null) {
    return {};
  }

  const candidate = error as Record<string, unknown>;
  return {
    statusCode:
      typeof candidate.statusCode === 'number' ? candidate.statusCode : undefined,
    message: typeof candidate.message === 'string' ? candidate.message : undefined,
  };
};

export const isLikelyNetworkError = (error: unknown): boolean => {
  if (error instanceof TypeError) {
    return true;
  }

  const normalized = normalizeNetworkError(error);
  if (normalized.statusCode === 0) {
    return true;
  }

  const message = normalized.message?.toLowerCase();
  if (!message) {
    return false;
  }

  return (
    message.includes('network') ||
    message.includes('internet') ||
    message.includes('connection') ||
    message.includes('timeout') ||
    message.includes('fetch')
  );
};

export const checkNetworkConnectivity = async (): Promise<boolean> => {
  const state = await NetInfo.fetch();
  if (!state.isConnected) {
    return false;
  }

  if (typeof state.isInternetReachable === 'boolean') {
    return state.isInternetReachable;
  }

  // Some platforms return null transiently; fall back to link connectivity.
  return true;
};
